import * as React from 'react';
import SponsorablePropertyCapabilityPackage from 'types/sponsorablePropertyCapabilityPackage';
import CircledIcon from 'components/CircledIcon';

interface Props {
  sponsorablePropertyCapabilityPackage: SponsorablePropertyCapabilityPackage;
}

const AddedSponsorablePropertyCapabilityPackage: React.FunctionComponent<
  Props
> = ({ sponsorablePropertyCapabilityPackage }: Props) => {
  const { quantity, organizationCapability } =
    sponsorablePropertyCapabilityPackage;
  const {
    id: organizationCapabilityId,
    description,
    name,
  } = organizationCapability;

  return (
    <div
      className="row"
      data-test={`added-sponsorable-property-capability-package-${organizationCapabilityId}`}
    >
      <div className="col-auto pr-0">
        <CircledIcon
          value="check"
          className="mr-2 text-white"
          backgroundColor="primary"
          opacity={1}
          size={18}
        />
      </div>
      <div className="col pl-0">
        <h6
          data-test={`added-sponsorable-property-capability-package-${organizationCapabilityId}-name`}
          className="mb-1"
        >
          {name}
        </h6>
        <div
          data-test={`added-sponsorable-property-capability-package-${organizationCapabilityId}-description`}
          className="compact-line-height"
        >
          {description}
        </div>
        <small
          data-test={`added-sponsorable-property-capability-package-${organizationCapabilityId}-quanitity`}
          className="compact-line-height text-muted"
        >{`Quantity: ${quantity}`}</small>
      </div>
    </div>
  );
};

export default AddedSponsorablePropertyCapabilityPackage;
